__turbopack_context__.v({
  "active": "ArticleToc-module-scss-module__y6oqBa__active",
  "tocContainer": "ArticleToc-module-scss-module__y6oqBa__tocContainer",
  "tocItem": "ArticleToc-module-scss-module__y6oqBa__tocItem",
  "tocLink": "ArticleToc-module-scss-module__y6oqBa__tocLink",
  "tocList": "ArticleToc-module-scss-module__y6oqBa__tocList",
  "tocTitle": "ArticleToc-module-scss-module__y6oqBa__tocTitle",
});
